import PropTypes from 'prop-types';
import { equals, head } from 'ramda';
import i18n from 'i18n';
import { isBlank } from 'utils/helperMethods';
import Presenter from 'utils/PropTypesPresenter';

export const buildNmlsCheckingServiceLink = nmls =>
  `https://www.nmlsconsumeraccess.org/Home.aspx/SubSearch?searchText=${nmls}&x=0&y=0`;

export default new Presenter(
  {
    id: PropTypes.number,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    profileImageUrl: PropTypes.string,
    profileVideoUrl: PropTypes.string,
    companyLogoUrl: PropTypes.string,
    applicationUrl: PropTypes.string,
    phoneNumber: PropTypes.string,
    companyName: PropTypes.string,
    companyNmls: PropTypes.number,
    location: PropTypes.string,
    nmls: PropTypes.number,
    email: PropTypes.string,
    aboutMe: PropTypes.string,
    last30DaysBidRequestsCount: PropTypes.number,
    last30DaysBidRequestsActiveBidsCount: PropTypes.number,
    totalBidRequestsCount: PropTypes.number,
  },
  {
    fullName(loanOfficer) {
      return `${this.firstName(loanOfficer)} ${this.lastName(loanOfficer)}`;
    },
    getNmls(loanOfficer) {
      const nmls = this.nmls(loanOfficer);
      return isBlank(nmls) ? '--' : nmls;
    },
    initials(user) {
      const [first, second] = this.fullName(user).split(' ');
      return `${head(first)}${head(second)}`;
    },
    phoneLink(loanOfficer) {
      const number = this.phoneNumber(loanOfficer);
      return `tel:*67${number.replace(/\D/g, '')}`;
    },
    branchLocation(loanOfficer) {
      const location = this.location(loanOfficer);
      if (isBlank(location)) return i18n.t(`presenters.LoanOfficerPresenter.notSet`);
      return location;
    },
    responseRate(loanOfficer) {
      const last30DaysBidRequestsCount = this.last30DaysBidRequestsCount(loanOfficer);
      const last30DaysBidRequestsActiveBidsCount = this.last30DaysBidRequestsActiveBidsCount(loanOfficer);

      if (
        isBlank(last30DaysBidRequestsCount) ||
        isBlank(last30DaysBidRequestsActiveBidsCount) ||
        equals(last30DaysBidRequestsCount, 0)
      )
        return null;

      const responseRate = (last30DaysBidRequestsActiveBidsCount / last30DaysBidRequestsCount) * 100;
      return equals(responseRate, 0) ? null : responseRate.toFixed(0);
    },
  },
);



// WEBPACK FOOTER //
// ./src/presenters/LoanOfficerPresenter.js